module.exports = __webpack_public_path__ + "img/maestro.8dd577e.svg";